// src/apiClient.js — final, maintenance-free API layer
import { API_BASE_URL } from './config';

export const apiClient = {
  get: (path) => apiClient._request('GET', path),
  post: (path, body) => apiClient._request('POST', path, body),
  put: (path, body) => apiClient._request('PUT', path, body),
  delete: (path) => apiClient._request('DELETE', path),

  _request: async (method, path, body = null) => {
    const token = localStorage.getItem('authToken');
    const url = `${API_BASE_URL}${path}`;
    
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;

    const config = { method, headers };
    if (body) config.body = JSON.stringify(body);

    const response = await fetch(url, config);

    // Auto-logout on 401 (token expired/invalid)
    if (response.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('userRole');
      localStorage.removeItem('userId');
      localStorage.removeItem('username');
      window.location.href = '/login';
      throw new Error('Session expired. Please log in again.');
    }

    if (!response.ok) {
      const errorText = await response.text().catch(() => 'Unknown error');
      throw new Error(`Request failed: ${response.status} ${errorText}`);
    }

    // Handle empty responses (e.g., DELETE)
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      return response.json();
    }
    return null;
  }
};